import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

import {
  SITUATION_FILTER_LABEL,
  buildSituationOptions,
} from "../hooks/situation-filter";

interface SituationFilterProps {
  situations: string[];
  value: string;
  onChange: (value: string) => void;
}

export function SituationFilter({
  situations,
  value,
  onChange,
}: SituationFilterProps) {
  const options = buildSituationOptions(situations);

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-muted-foreground">
        {SITUATION_FILTER_LABEL}
      </span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-8 w-[200px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option} value={option}>
              {option}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
